(function () {
  'use strict';

  function initCarousel(sectionRoot) {
    var track = sectionRoot.querySelector('[data-photo-carousel]');
    if (!track) return;
    var prev = sectionRoot.querySelector('[data-carousel-prev]');
    var next = sectionRoot.querySelector('[data-carousel-next]');
    function scrollBy(dx) {
      track.scrollBy({ left: dx, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () {
      scrollBy(-300);
    });
    if (next) next.addEventListener('click', function () {
      scrollBy(300);
    });
  }

  function applyFilters(sectionRoot) {
    var searchInput = sectionRoot.querySelector('[data-hub-search-input]');
    var ratingSel = sectionRoot.querySelector('[data-hub-rating-filter]');
    var mediaCb = sectionRoot.querySelector('[data-hub-media-filter]');
    var list = sectionRoot.querySelector('[data-hub-list]');
    if (!list) return;

    var q = searchInput ? String(searchInput.value || '').trim().toLowerCase() : '';
    var rating = ratingSel ? ratingSel.value : 'all';
    var mediaOnly = mediaCb ? mediaCb.checked : false;
    var anyFilter = q.length > 0 || rating !== 'all' || mediaOnly;

    var items = list.querySelectorAll('.cosmic-reviews-hub__item');
    var visibleIds = new Set();

    items.forEach(function (item) {
      var stars = parseInt(item.getAttribute('data-hub-rating'), 10);
      if (isNaN(stars) || stars < 1) stars = 5;
      if (stars > 5) stars = 5;
      var hm = item.getAttribute('data-hub-has-media') === '1';
      var txt = (item.textContent || '').toLowerCase();
      var ok = true;
      if (rating !== 'all' && String(stars) !== rating) ok = false;
      if (mediaOnly && !hm) ok = false;
      if (q && txt.indexOf(q) === -1) ok = false;
      item.classList.toggle('is-hub-filter-hidden', !ok);
      if (ok) {
        var bid = item.getAttribute('data-hub-review-block');
        if (bid) visibleIds.add(bid);
      }
    });

    var cells = sectionRoot.querySelectorAll('.cosmic-review-carousel__cell');
    cells.forEach(function (cell) {
      if (cell.getAttribute('data-hub-demo') === '1') {
        cell.classList.toggle('is-hub-filter-hidden', anyFilter);
        return;
      }
      var bid = cell.getAttribute('data-review-block');
      if (!bid) return;
      cell.classList.toggle('is-hub-filter-hidden', !visibleIds.has(bid));
    });

    var fb = sectionRoot.querySelector('[data-hub-fallback]');
    if (fb) fb.classList.toggle('is-hub-filter-hidden', anyFilter);

    var hasItems = items.length > 0;
    var hasFb = !!fb;
    var visibleCount = 0;
    items.forEach(function (item) {
      if (!item.classList.contains('is-hub-filter-hidden')) visibleCount++;
    });

    var showEmpty =
      (hasItems && visibleCount === 0) ||
      (!hasItems && hasFb && anyFilter);

    var emptyEl = sectionRoot.querySelector('[data-hub-empty]');
    if (emptyEl) emptyEl.hidden = !showEmpty;
  }

  function bind(sectionRoot) {
    initCarousel(sectionRoot);
    var searchInput = sectionRoot.querySelector('[data-hub-search-input]');
    var ratingSel = sectionRoot.querySelector('[data-hub-rating-filter]');
    var mediaCb = sectionRoot.querySelector('[data-hub-media-filter]');
    function run() {
      applyFilters(sectionRoot);
    }
    var debounce;
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(debounce);
        debounce = setTimeout(run, 160);
      });
      searchInput.addEventListener('search', run);
    }
    if (ratingSel) ratingSel.addEventListener('change', run);
    if (mediaCb) mediaCb.addEventListener('change', run);
    run();
  }

  function initShopifySection(sectionEl) {
    if (!sectionEl) return;
    if (sectionEl.dataset.cosmicReviewsHubInit) return;
    var hubRoot = sectionEl.querySelector('[data-cosmic-reviews-hub-root]');
    if (!hubRoot) return;
    sectionEl.dataset.cosmicReviewsHubInit = '1';
    bind(hubRoot);
  }

  window.cosmicReviewsHubInitSection = initShopifySection;

  if (!window.__cosmicReviewsHubBootstrapped) {
    window.__cosmicReviewsHubBootstrapped = true;

    function boot() {
      document.querySelectorAll('.shopify-section').forEach(function (sec) {
        if (sec.querySelector('[data-cosmic-reviews-hub-root]')) initShopifySection(sec);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (evt) {
      var id = evt.detail && evt.detail.sectionId;
      if (!id) return;
      var el = document.getElementById('shopify-section-' + id);
      if (!el) return;
      delete el.dataset.cosmicReviewsHubInit;
      initShopifySection(el);
    });
  }
})();
